<template>
<div>

    <div class="col-12 d-flex px-0" v-if="!$route.path.includes('partner') && complementaryRegister" :class="isModal ? 'justify-content-center' : ''">
        <div class="pl-0">
            <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>
                <div>
                    Ficha cadastral PJ preenchida;
                </div>
            </h6>
            <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>
                <div>
                    Declaração de instituições financeiras;
                </div>
            </h6>
            <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>
                <div>
                    Faturamento dos últimos 24 meses;
                </div>
            </h6>
        </div>
        <div class="pl-5 ml-n1">
            <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>
                <div>
                    Balanço dos últimos 24 meses;
                </div>
            </h6>
            <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>
                <div>
                    DRE dos últimos 24 meses.
                </div>
            </h6>
        </div>
    </div>

    <div class="col-10 d-flex px-0" v-else-if="!$route.path.includes('partner')">
        <div class="pl-0">
            <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>
                <div>
                    Contrato Social e/ou última atualização contratual;
                </div>
            </h6>
            <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>
                <div>
                    Ata de assembleia (se houver);
                </div>
            </h6>
            <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>
                <div>
                    Cartão CNPJ.
                </div>
            </h6>
        </div>
    </div>

    <div class="col-10 d-flex px-0" v-if="$route.path.includes('pf') && complementaryRegister">
        <div class="pl-0">
            <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>
                <div>
                    Ficha cadastral PF preenchida;
                </div>
            </h6>
            <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>
                <div>
                    Declaração do imposto de renda.
                </div>
            </h6>
        </div>
    </div>

    <div class="col-10 d-flex px-0" v-else-if="$route.path.includes('pf')">
        <div class="pl-0">
            <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>
                <div>
                    RG e CPF ou CNH vigente;
                </div>
            </h6>
            <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>
                <div>
                    Comprovante de residência.
                </div>
            </h6>
        </div>
    </div>

    <div class="col-10 d-flex px-0" v-if="$route.path.includes('pj') && complementaryRegister" :class="isModal ? 'justify-content-center' : ''">
        <div class="pl-0">
            <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>
                <div>
                    Balanço dos últimos 24 meses;
                </div>
            </h6>
            <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>
                <div>
                    DRE dos últimos 24 meses.
                </div>
            </h6>
        </div>
    </div>

    <div class="col-10 d-flex px-0" v-else-if="$route.path.includes('pj')" :class="isModal ? 'justify-content-center' : ''">
        <div class="pl-0">
            <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>
                <div>
                    Contrato Social e/ou última atualização contratual;
                </div>
            </h6>
            <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>
                <div>
                    Ata de assembleia (se houver);
                </div>
            </h6>
            <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>
                <div>
                    Cartão CNPJ.
                </div>
            </h6>
        </div>
    </div>

    <div class="col-10 d-flex px-0" v-if="$route.path.includes('procurator')" :class="isModal ? 'justify-content-center' : ''">
        <div class="pl-0">
            <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>
                <div>
                    RG e CPF ou CNH vigente;
                </div>
            </h6>
            <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>
                <div>
                    Comprovante de residência;
                </div>
            </h6>
            <h6 class="px-0 mt-2 c-ndarkfour regular d-flex">
                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>
                <div>
                    Procuração P.F. (aval) dos procuradores.
                </div>
            </h6>
        </div>
    </div>

</div>
</template>

<script>
import CheckPayment from '@/components/icons/CheckPayment'
export default {
    components: {
        CheckPayment
    },
    props: {
        isModal: {
            type: Boolean,
            default: false
        },
        complementaryRegister: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style>

</style>